import React, { useEffect, useState } from "react";
import { Title30 } from "@stylesheets";
import { View, Text } from "react-native";
import { AccountThunks, HomeScreens, ProfileScreens } from "@modules";
import { NavigationProp } from "@react-navigation/native";
import CGUCheckbox from "./CGUCheckbox";
import { TouchableOpacity } from "react-native-gesture-handler";
import { Button } from "../../../../modules/profile/screens/SettingsScreen/MfaSetup/Button";
import { I18n } from "react-redux-i18n";
import { FloatTextInput } from "@atomic/molecules";
import { Icon } from "@atomic/atoms/Icon";
import { InfoBox } from "@atomic/molecules/InfoBox";
import { useDispatch, useSelector } from "react-redux";
import { GlobalState, LoaderActions } from "@redux";
import { useDevices } from "@hooks";
import { createStyles } from "./styles";
import { Images } from "@assets";
interface IProps {
  navigation: NavigationProp<any>;
}

export const CGU: React.FC<IProps> = React.memo(({ navigation }) => {
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isNewsletterAccepted, setIsNewsletterAccepted] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isMobile] = useDevices();

  const dispatch = useDispatch();
  const userInfo = useSelector((state: GlobalState) => state.auth.userInfo);

  const isFormValid =
    firstName.trim().length >= 2 && firstName.trim().length <= 100 &&
    lastName.trim().length >= 2 && lastName.trim().length <= 100 &&
    isTermsAccepted;

  const handleFinishSetup = async () => {
    dispatch(LoaderActions.setLoading(true));
    await dispatch(
      AccountThunks.sendTosConsent({
        firstName,
        lastName,
        marketing: isNewsletterAccepted,
        source: "foodi-monorepo",
      })
    )
    if(!userInfo?.idHoldingView) {
      navigation.navigate(HomeScreens.PROFILE_STACK, {
        screen: ProfileScreens.BADGE_SETUP,
      })
    }
    dispatch(LoaderActions.setLoading(false));
  };

  const handleNewWindow = (url: string) => {
    window.open(url, "tab");
  };

  useEffect(() => {
    setFirstName(userInfo?.firstName || "");
    setLastName(userInfo?.lastName || "");
  }, []);

  const styles = createStyles(isMobile);

  return (
    <View style={styles.container}>
      <View style={styles.backGroundImage}>
        <Images.CGUBackground />
      </View>
      <View style={styles.contentContainer}>
        <Title30 style={styles.welcomeTitle}>
          {I18n.t("homepage.welcomingSentence.accountSetup.welcomeTitle")}
        </Title30>

        <View style={styles.mainCard}>
          <View style={styles.sectionHeader}>
            <Icon name="Profile_black" size={20} style={styles.sectionIcon} />
            <Text style={styles.sectionTitle}>
              {I18n.t(
                "homepage.welcomingSentence.accountSetup.completeProfile"
              )}
            </Text>
          </View>

          <Text style={styles.sectionSubtitle}>
            {I18n.t("homepage.welcomingSentence.accountSetup.profileSubtitle")}
          </Text>

          <View style={styles.inputsContainer}>
            <FloatTextInput
              value={firstName}
              onChangeValue={(value) => setFirstName(value)}
              textPlaceHolder={`${I18n.t("account.firstName")}*`}
            />
            <FloatTextInput
              value={lastName}
              onChangeValue={(value) => setLastName(value)}
              textPlaceHolder={`${I18n.t("account.lastName")}*`}
            />
          </View>

          <View style={styles.checkboxContainer}>
            <CGUCheckbox
              label={
                <Text>
                  {I18n.t(
                    "homepage.welcomingSentence.accountSetup.termsConditions"
                  )}{" "}
                  <TouchableOpacity
                    onPress={() =>
                      handleNewWindow(
                        `${window.config.CGU}`
                      )
                    }
                  >
                    <Text style={styles.linkText}>
                      {I18n.t(
                        "homepage.welcomingSentence.accountSetup.termsConditionsLink"
                      )}
                    </Text>
                  </TouchableOpacity>{" "}
                  {I18n.t(
                    "homepage.welcomingSentence.accountSetup.termsConditionsEnd"
                  )}
                </Text>
              }
              checked={isTermsAccepted}
              onChange={() => setIsTermsAccepted(!isTermsAccepted)}
            />

            <CGUCheckbox
              label={I18n.t(
                "homepage.welcomingSentence.accountSetup.newsletter"
              )}
              checked={isNewsletterAccepted}
              onChange={() => setIsNewsletterAccepted(!isNewsletterAccepted)}
            />
          </View>

          <Text style={styles.validationText}>
            {!isFormValid
              ? I18n.t(
                  "homepage.welcomingSentence.accountSetup.validationMessage"
                )
              : " "}
          </Text>

          <View style={styles.buttonContainer}>
            <Button
              onPress={handleFinishSetup}
              disabled={!isFormValid}
              style={[styles.finishButton]}
            >
              <Text style={[styles.buttonText]}>
                {I18n.t("homepage.welcomingSentence.accountSetup.finishSetup")}
              </Text>
            </Button>
          </View>

          <Text style={styles.mandatoryTextInCard}>
            {I18n.t("homepage.welcomingSentence.accountSetup.mandatoryFields")}
          </Text>
        </View>

        {//!userInfo?.holdingName
        // remove this condition and go back to holdingName check once the association flow is released, for now it is useless
         false && (
          <InfoBox
            type="info"
            collapsible={isMobile}
            defaultOpen={!isMobile}
            title={
              <View style={styles.infoBoxTitleRow}>
                <Text style={styles.infoBoxTitle}>
                  {I18n.t(
                    "homepage.welcomingSentence.accountSetup.nextStepTitle"
                  )}
                </Text>
                <Text style={styles.infoBoxTime}>
                  {I18n.t(
                    "homepage.welcomingSentence.accountSetup.timeEstimate"
                  )}
                </Text>
              </View>
            }
          >
            <Text style={styles.infoBoxText}>
              {I18n.t(
                "homepage.welcomingSentence.accountSetup.nextStepDescription"
              )}
            </Text>
          </InfoBox>
        )}

        <Text style={styles.privacyText}>
          {I18n.t("homepage.welcomingSentence.accountSetup.privacyPolicy")}{" "}
          <TouchableOpacity
            onPress={() =>
              handleNewWindow(
                `${window.config.PUD}`
              )
            }
          >
            <Text style={styles.linkText}>
              {I18n.t(
                "homepage.welcomingSentence.accountSetup.privacyPolicyLink"
              )}
            </Text>
          </TouchableOpacity>
        </Text>

        <Text style={styles.supportText}>
          {I18n.t("homepage.welcomingSentence.accountSetup.needHelp")}{" "}
          <TouchableOpacity
            onPress={() => handleNewWindow(`${window.config.ZENDESK_BASE_URL}`)}
          >
            <Text style={styles.linkText}>
              {I18n.t("homepage.welcomingSentence.accountSetup.contactSupport")}
            </Text>
          </TouchableOpacity>
        </Text>
      </View>
    </View>
  );
});
